import * as React from 'react';
import * as classnames from 'classnames';

import Icon from './Icon';

interface Props {
	value: number;
	max?: number;
	min?: number;
	className?: string;
	onChange(value: number): void;
}

const DEFAULT_RANGE_MINIMUM: number = 0;
const DEFAULT_RANGE_MAXIMUM: number = 14;

export default class RangeSlider extends React.Component<Props, {}> {

	constructor(props: Props, context: any) {
		super(props, context);
		this.handleSlide = this.handleSlide.bind(this);
	}

	public render() {
		const { min, max, value } = this.props;
		const className = classnames('slider', this.props.className || '');
		return <div className={className}>
			<Icon name='search-minus' fixedWidth className='slider-indicator' />
			<input
				className='slider-input'
				type='range'
				value={value}
				min={min || DEFAULT_RANGE_MINIMUM}
				max={max || DEFAULT_RANGE_MAXIMUM}
				onChange={this.handleSlide}
				step={1}
			/>
			<Icon name='search-plus' size='lg' fixedWidth className='slider-indicator' />
		</div>;
	}

	private handleSlide(event: React.ChangeEvent<HTMLInputElement>) {
		const value: string = (event.currentTarget as HTMLInputElement).value;
		this.props.onChange(parseInt(value, 10));
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/widgets/RangeSlider.tsx